module.exports = __webpack_public_path__ + "static/img/syxt_img_illtration.746146a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syxt_img_illtration.png
// module id = +20G
// module chunks = 0